import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap, Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const authedUser = await login(email, password);
      if (authedUser?.role !== "admin") {
        logout();
        setError("Ez a fiók nem admin. A backend .env ADMIN_EMAIL / ADMIN_PASSWORD párossal jelentkezz be (/admin/login).");
        setLoading(false);
        return;
      }
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Bejelentkezés sikertelen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark min-h-screen bg-anthracite-900 text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4" /> Vissza a főoldalra
        </Link>

        <div className="glass rounded-3xl p-8">
          <div className="flex items-center gap-2 mb-2">
            <Zap className="w-6 h-6 text-electric" strokeWidth={1.5} />
            <span className="font-heading text-xl font-semibold">Auto<span className="text-electric">park</span></span>
          </div>
          <h1 className="font-heading text-2xl font-light mt-4">Admin bejelentkezés</h1>
          <p className="text-slate-400 text-sm mt-1">Jelentkezz be a készlet kezeléséhez.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs tracking-[0.15em] uppercase text-slate-400 block mb-2">Email</label>
              <input
                data-testid="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/[0.03] border border-white/10 rounded-xl p-3 text-sm text-white focus:border-electric outline-none transition-colors"
              />
            </div>
            <div>
              <label className="text-xs tracking-[0.15em] uppercase text-slate-400 block mb-2">Jelszó</label>
              <input
                data-testid="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white/[0.03] border border-white/10 rounded-xl p-3 text-sm text-white focus:border-electric outline-none transition-colors"
              />
            </div>

            {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}

            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full bg-electric hover:bg-electric-light disabled:opacity-50 text-white font-medium transition-all"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Bejelentkezés
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
